import { ComponentChildren, JSX } from 'preact';
import { ChorusMark } from './ChorusMark';
import { IconBack } from './Icons';
import styles from './ChorusHeader.module.css';

interface ChorusHeaderProps {
  title?: string;
  back?: boolean;
  onBack?: () => void;
  animate?: boolean;
  right?: ComponentChildren;
}

export function ChorusHeader({
  title,
  back = false,
  onBack,
  animate = false,
  right,
}: ChorusHeaderProps): JSX.Element {
  return (
    <header class={styles.header}>
      <div class={styles.left}>
        {back ? (
          <button
            type="button"
            onClick={onBack}
            class={styles.backBtn}
            aria-label="Back"
          >
            <IconBack />
          </button>
        ) : (
          <ChorusMark size={28} animate={animate} />
        )}
        <span class={`${styles.wordmark} ${title ? styles.titleSize : ''}`}>
          {title || 'OurTake'}
        </span>
      </div>
      {right && <div class={styles.right}>{right}</div>}
    </header>
  );
}
